<!--
 * @Author: your name
 * @Date: 2021-12-16 18:51:19
 * @LastEditTime: 2022-10-18 11:01:13
 * @LastEditors: zyq yqzhang01@gongsibao.com
 * @Description: 小巨人第三步
-->
<template>
  <div>
    <div class="lit-title">
      <span class="lit-ban"></span>
      <span class="lit-txt2">经济效益测评</span>
    </div>
    <!-- 表单 -->
    <div class="lit-form">
      <div class="lit-forms">
        <span class="lit-form-tit">企业技术和产品有自身独特优势，主导产品在全国细分市场占有率达到 10%以上，且享有较高知名度和影响力</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业拥有直接面向市场并具有竞争优势的自主品牌</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业年度营业收入和研发费用的占比</span>
        <div class="lit-selects">
          <span
              class="lit-select"
              v-for="(select, index) in selectOptions"
              :key="index"
              :class="activeIndex === index ? 'lit-active' : ''"
              @click="switchIndex(index)"
          >{{ select }}</span
          >
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业自建或与高等院校、科研机构联合建立研发机构，设 立技术研究院、企业技术中心、企业工程中心、院士专家工 作站、博士后工作站等</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业拥有 2 项以上与主导产品相关的I类知识产权，且实际 应用并已产生经济效益</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业近三年获得国家级科技奖励，并在获奖单位中排名前三</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业近三年进入“创客中国”中小企业创新创业大赛全国50 强企业组名单</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业位于产业链关键环节，围绕重点产业链实现关键基础技术和产品的产业化应用，发挥“补短板”“锻长板”“填空白”等重要作用</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业主导产品原则上属于以下重点领域</span>
        <div class="lit-radios">
          <span
              class="lit-radio"
              :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
              @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
<!--      <div class="lit-forms">-->
<!--        <span class="lit-form-tit">企业主导产品原则上属于以下重点领域</span>-->
<!--        <div class="lit-selects">-->
<!--          <span class="lit-select" class="lit-active" @click="selectClick('q532', '是')" ></span>-->
<!--        </div>-->
<!--      </div>-->
      <div class="lit-forms">
        <span class="lit-form-tit">企业主导产品原则上属于以下重点领域</span>
        <div class="lit-selects">
          <span
              class="lit-select"
              v-for="(select, index) in selectOptions"
              :key="index"
              :class="activeIndex === index ? 'lit-active' : ''"
              @click="switchIndex(index)"
          >{{ select }}</span
          >
        </div>
      </div>






      <div class="lit-forms">
        <span class="lit-form-tit"
          >2、截止上年末，企业从事特定细分市场时间是否达到3年及以上，且主营业务收入占营业收入达70%以上？</span
        >
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q532 == '是' ? 'lit-active' : ''"
            @click="selectClick('q532', '是')"
            >是</span
          >
          <span
            class="lit-radio"
            :class="giantForm.q532 == '否' ? 'lit-active' : ''"
            @click="selectClick('q532', '否')"
            >否</span
          >
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit"
          >3、产品在细分市场占有率是否位于全省前3位，国内细分行业中享有较高知名度和影响力？</span
        >
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q533 == '是' ? 'lit-active' : ''"
            @click="selectClick('q533', '是')"
            >是</span
          >
          <span
            class="lit-radio"
            :class="giantForm.q533 == '否' ? 'lit-active' : ''"
            @click="selectClick('q533', '否')"
            >否</span
          >
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit"
          >4、是否近2年主营业务收入或净利润的平均增长率达到5%以上，且企业资产负债率不高于70%？</span
        >
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q534 == '是' ? 'lit-active' : ''"
            @click="selectClick('q534', '是')"
            >是</span
          >
          <span
            class="lit-radio"
            :class="giantForm.q534 == '否' ? 'lit-active' : ''"
            @click="selectClick('q534', '否')"
            >否</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../../index.less';
export default {
  data() {
    return {
      value: '',
      activeIndex: '',
      giantForm: {
        q531: '',
        q532: '',
        q533: '',
        q534: '',
      },
      selectOptions: [
        '上年度营业收入在1亿元及以上，且近2年研发经费支出占营业收入比重不低于3%',
        '上年度营业收入5000万元（含）—1亿元（不含），且近2年研发经费支出占营业收入比重不低于6%',
        '上年度营业收入不足5000万元，同时近2年内新增股权融资额（实缴）8000万元（含）以上，且研发投入经费3000万元（含）以上，研发人员占企业职工总数比例50%（含）以上',
        '不满足上述指标'
      ],
      selectOptions1: [
        '上年度营业收入在1亿元及以上，且近2年研发经费支出占营业收入比重不低于3%',
        '上年度营业收入5000万元（含）—1亿元（不含），且近2年研发经费支出占营业收入比重不低于6%',
        '上年度营业收入不足5000万元，同时近2年内新增股权融资额（实缴）8000万元（含）以上，且研发投入经费3000万元（含）以上，研发人员占企业职工总数比例50%（含）以上',
        '不满足上述指标'
      ],
    };
  },
  methods: {
    selectClick(type, val) {
      this.giantForm[type] = val;
    },
    switchIndex(index) {
      this.activeIndex = index;
      this.giantForm.q531 = this.selectOptions[index];
      console.log(this.giantForm.q531);
    },
  },
};
</script>
<style lang="less" scoped>
.lit-selects {
  .lit-select {
    display: inline-block;
    // width: 1rem;
    padding: 0.15rem 0.1rem;
    text-align: left;
    background: #ffffff;
    border-radius: 0.06rem;
    border: 1px solid #e9ebef;
    margin: 0 0.2rem 0.2rem 0;
  }
  .lit-active {
    color: #0072f7;
    border-color: #0072f7;
  }
}
</style>
